import ContentChartTitle from './ContentChartTitle'

export default ContentChartTitle



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/ContentChartTitle/index.js